import Cookies from 'js-cookie';

import {OmicronResponse} from '@web-landing/omicron/schemas';

export const setOidSegments = (data: OmicronResponse) => {
  if (!localStorage || typeof localStorage === 'undefined') {
    return;
  }

  if (data.segments) {
    localStorage.setItem('omicronParams', JSON.stringify(data.segments));
  }

  const userId = Cookies.get('oid');

  if (userId) {
    localStorage.setItem('userId', userId);
  }
};
